import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import {UserCircleIcon} from "@heroicons/react/24/solid";
import { BookOpenIcon, CalendarDaysIcon, FireIcon, ChevronRightIcon, ChatBubbleLeftRightIcon, ChatBubbleBottomCenterIcon, InformationCircleIcon, Bars3Icon, HomeIcon} from "@heroicons/react/24/outline";
import SlidePanel from "../components/SlidePanel";
import { useAuth } from "../contexts/authContext";

export default function Navbar() {
  const [showNav, setShowNav] = useState(true);
  const [showDrawer, setShowDrawer] = useState(false);
  const navigate = useNavigate();
  const { token, isLoggedIn } = useAuth();
  const { logout } = useAuth();  // get the login function from context
  
  const handleLogout = () => {
    localStorage.clear();
    //setToken(null);
    logout();
    navigate("/login");
  };

  const accountLinks = [
    { to: "/account", label: "My Account Settings" },
    { to: "/preferences", label: "Preferences" },
  ]
  const chatLinks = [
    { to: "/chat", label: "Chat with Sous.", icon: ChatBubbleBottomCenterIcon },
    { to: "/conversations", label: "Recent Chat History", icon: ChatBubbleLeftRightIcon },
  ]
  const recipeLinks = [
    { to: "/recipes", label: "Recipe Book", icon: BookOpenIcon },
    { to: "/calendar", label: "Calendar", icon: CalendarDaysIcon },
    { to: "/mealplans", label: "Mealplans", icon: FireIcon },
  ]

  return (
    <>
    {/*
      <nav
        className={`z-20 bg-sage text-white px-4 pt-[max(0.75rem,env(safe-area-inset-top))] pb-3 flex justify-between items-center shadow`}
      >
        <Link to="/" className="text-2xl font-light tracking-tight leading-tight">
          Sous.
        </Link>

        {token ? (
          <button onClick={() => setShowDrawer(true)} className="focus:outline-none">
            <Bars3Icon className="h-8 w-8 text-white" />
          </button>
        ) : (
          <div className="flex items-center gap-4">
            <Link to="/help" className="block py-2">
              Help
            </Link>
            |
            <Link
              to="/login"
              className="text-sm bg-white text-sage font-semibold px-4 py-1.5 rounded hover:bg-sage-100 transition"
            >
              Log In
            </Link>
          </div>
        )}
      </nav>
      //pt-[max(0.75rem,env(safe-area-inset-top))]
      */}
      {token ? ( 
        <nav 
          className={`z-20 bg-sage text-white px-4 pb-3 flex justify-between items-center shadow pt-[max(0.75rem,var(--safe-area-inset-top))]`}>
          <Link to="/" className="text-2xl font-light tracking-tight leading-tight">
            Sous.
          </Link>
          <button onClick={() => setShowDrawer(true)} className="focus:outline-none">
            <Bars3Icon className="h-8 w-8 text-white" />
          </button>
        </nav>
       ) : ( "")}
      
      <SlidePanel
        isOpen={showDrawer}
        onClose={() => setShowDrawer(false)}
        title="Menu"
      >
            <div className="flex-1 overflow-y-auto space-y-4">

              <div className="rounded-xl bg-sage p-4 text-white">
                <h2 className="text-lg font-semibold">Account</h2>
                {accountLinks.map(({ to, label }) => (
                  <Link key={to} to={to} onClick={() => setShowDrawer(false)}>
                    <div className="px-2 py-1">{label}</div>
                  </Link>
                ))}
              </div>

              <Link
                key="/"
                to='/'
                onClick={() => setShowDrawer(false)}
                className="flex items-center justify-between px-8 py-4 bg-gray-100 rounded-lg hover:bg-gray-200 transition"
              >
                <div className="flex items-center gap-3">
                  <HomeIcon className="h-6 w-6 text-sage" />
                  <span className="font-medium">Home</span>
                </div>
                <ChevronRightIcon className="h-6 w-6 text-sage" />
              </Link>

              <div className="rounded-xl bg-gray-100 p-4 text-charcoal">
                <h2 className="text-lg font-semibold mb-2">Conversations</h2>
                {chatLinks.map(({ icon: Icon, to, label }) => (
                  <Link
                  key={to}
                  to={to}
                  onClick={() => setShowDrawer(false)}
                  className="flex items-center justify-between p-4 bg-gray-100 rounded-lg hover:bg-gray-200 transition"
                >
                  <div className="flex items-center gap-3">
                    <Icon className="h-6 w-6 text-sage" />
                    <span className="font-medium">{label}</span>
                  </div>
                  <ChevronRightIcon className="h-6 w-6 text-sage" />
                </Link>
                  ))}
              </div>

              <div className="rounded-xl bg-gray-100 p-4 text-charcoal">
                <h2 className="text-lg font-semibold mb-2">Recipes & planning</h2>
                  {recipeLinks.map(({ icon: Icon, to, label }) => (
                  <Link
                    key={to}
                    to={to}
                    onClick={() => setShowDrawer(false)}
                    className="flex items-center justify-between p-4 bg-gray-100 rounded-lg hover:bg-gray-200 transition"
                  >
                    <div className="flex items-center gap-3">
                      <Icon className="h-6 w-6 text-sage" />
                      <span className="font-medium">{label}</span>
                    </div>
                    <ChevronRightIcon className="h-6 w-6 text-sage" />
                  </Link>
                  ))}
              </div>

              <Link
                key="/help"
                to='/help'
                onClick={() => setShowDrawer(false)}
                className="flex items-center justify-between px-8 py-4 bg-gray-100 rounded-lg hover:bg-gray-200 transition"
              >
                <div className="flex items-center gap-3">
                  <InformationCircleIcon className="h-6 w-6 text-sage" />
                  <span className="font-medium">Help</span>
                </div>
                <ChevronRightIcon className="h-6 w-6 text-sage" />
              </Link>

              <div className="rounded-xl bg-gray-100 text-charcoal">
                <button
                  onClick={() => {
                    handleLogout();
                    setShowDrawer(false);
                  }}
                  className="rounded-xl w-full  flex items-center justify-between block px-8 py-4 hover:bg-red-400 hover:text-white"
                >
                  Logout
                </button>
              </div>

            </div>
      </SlidePanel>


    </>
  );
}
